import React, { useContext } from 'react';
import { Datacontext } from '../../context/dataContext';
import { motion } from "framer-motion";

const HeaderMarquee = () => {
    const { marquee, loading } = useContext(Datacontext);

    if (loading) return null;

    if (!marquee || marquee.status !== 'active' || !marquee.text) {
        return null;
    }

    const displayText = marquee.text.toUpperCase();

    return (
        <div className="header-marquee-wrapper">
            <div className="marquee-label">
                ANNOUNCEMENT
            </div>
            
            <div className="marquee-body">
                <div className="motion-container">
                    <motion.div
                        className="motion-content"
                        animate={{ x: ["0%", "-40%"] }}
                        transition={{
                            ease: "linear",
                            duration: 20, // Adjust speed (higher = slower)
                            repeat: Infinity,
                        }}
                    >
                        {/* Render text twice for a seamless infinite loop */}
                        <span className="motion-text">{displayText}</span>
                        <span className="motion-text">{displayText}</span>
                    </motion.div>
                </div>
            </div>

            <style>{`
                .header-marquee-wrapper {
                    display: flex;
                    align-items: center;
                    background: #E6E6FA; 
                    height: 35px;
                    overflow: hidden;
                    border-bottom: 1px solid rgba(0,0,0,0.1);
                }

                .marquee-label {
                    background: #ef4444; 
                    color: white;
                    padding: 0 15px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-weight: bold;
                    font-size: 11px;
                    z-index: 10; /* Keeps label above moving text */
                    box-shadow: 5px 0 10px rgba(0,0,0,0.1);
                }

                .marquee-body {
                    flex: 1;
                    position: relative;
                }

                .motion-container {
                    overflow: hidden;
                    white-space: nowrap;
                    width: 100%;
                }

                .motion-content {
                    display: inline-flex;
                    will-change: transform;
                }

                .motion-text {
                    color: #1A1A2E;
                    font-weight: 600;
                    padding-right: 100px; /* Gap between loop repetitions */
                    font-size: 0.9rem;
                    display: inline-block;
                }
            `}</style>
        </div>
    );
};

export default HeaderMarquee;